import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NetworkCreateDialog from 'routes/Network/containers/NetworkCreateDialog';
import NetworkdIdList from './containers/NetworkdIdList';
import NetwordIdCreate from './containers/NetworkIdCreate';
import NetoworkIdView from './containers/NetworkdIdView';
import { SYSTEM_CONFIGURATION_ROUTE, NETWORK_ID_ROUTE, NETWORK } from '../../constants';

interface Props {
}

const DialedDigitExtractionServer: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${NETWORK_ID_ROUTE}`}>
        <NetworkdIdList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${NETWORK_ID_ROUTE}/create`}>
        <NetwordIdCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${NETWORK_ID_ROUTE}/view`}>
        <NetoworkIdView />
      </Route>
      <NetworkCreateDialog />
    </Fragment>
  );
};

export default DialedDigitExtractionServer;
